module.controller('consumerChoiceCtrl', ['$state', 'baseURI', '$http', '$stateParams', '$scope', 'brandService', '$window', 'Session', function($state, baseURI, $http, $stateParams, $scope, brandService, $window, Session) {
  $scope.amount = $stateParams.amount;
  $scope.name = $stateParams.sender;

  // check if email param is included and populated with a phone number instead of email
  var emailOrPhone = $stateParams.email;
  if (emailOrPhone && !emailOrPhone.includes('@')) {
    $scope.formData.phone = emailOrPhone.replace(/[\(\)\.\-\ ]/g, '');
  } else {
    $scope.formData.email = $stateParams.email;
    $scope.formData.phone = $stateParams.phone && $stateParams.phone.replace(/[\(\)\.\-\ ]/g, '');
  }

  if($scope.brand.name === 'uptogether') {
    $scope.info = {
      virtual: {
        type: 'Virtual',
        redirect: {
          state: 'member.home.virtual.step1',
        },
        text: 'View your virtual card number and use it for online purchases or with Apple Pay, Google Pay, and Samsung Pay.',
        cta: 'View Virtual Mastercard',
      },
      bank: {
        type: 'Bank',
        redirect: {
          state: 'member.home.bank/add.step1',
          params: { redirect: 'member.home.bank/transfer.step1({transferType:"withdraw"})' },
        },
        text: 'Withdraw these funds to your bank account.',
        cta: 'Withdraw to Bank Account',
      },
      check: {
        type: 'Check',
        redirect: {
          state: 'member.home.send-check.step1',
        },
        text: 'Receive a paper check in the mail.',
        cta: 'Receive a Paper Check',
      }
    };
  } else {
    $scope.info = {
      virtual: {
        type: 'Virtual',
        redirect: {
          state: 'member.home.virtual.step1',
        },
        text: 'View your virtual card number and use it for online purchases or with Apple Pay, Google Pay, and Samsung Pay.',
        cta: 'View Virtual Mastercard',
      },
      bank: {
        type: 'Bank',
        redirect: {
          state: 'member.home.ach.step1',
        },
        text: 'Withdraw these funds to your bank account via ACH. ',
        cta: 'Withdraw to Bank Account',
      },
      check: {
        type: 'Check',
        redirect: {
          state: 'member.home.send-check.step1',
        },
        text: 'Receive a paper check in the mail.',
        cta: 'Receive a Paper Check',
      }
    };
  }

  $scope.onSelect = function(option) {
    $scope.selected = option;
  };

  $scope.selected = $scope.info.virtual;

  $scope.onContinue = function(option) {
    if ($stateParams.redeemCode) {
      $state.go('root.redeem.virtual', {
        RedeemCode: $stateParams.redeemCode,
        redirect: option.redirect,
      });
    } else {
      $state.go('root.choice.step2', {
        redirect: option.redirect,
      });
    }
  };
}]);
